import { useEffect } from "react";

export type callbackFunc = (isVisible: boolean) => void

function useIsVisible(callback: callbackFunc) {
  const [visibilityChange, visible] = ["visibilitychange", "visible"]
  const onVisibilityChange = () => {
    callback(document.visibilityState === visible)
  }

  useEffect(() => {
    document.addEventListener(visibilityChange, onVisibilityChange)

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange)
    }
  })
}

export default useIsVisible
